/* ==========================================================================
   Elevate Floors — página ABOUT

   Quatro comportamentos, todos re-executáveis (o editor de tema troca o nó da
   section a cada save e dispara shopify:section:load):

     1. parallax do hero
     2. parallax do story, com vídeo e foto em SENTIDOS OPOSTOS
     3. entrada da frase do manifesto e da foto circular, uma vez só
     4. contagem dos três números, uma vez só

   Nada aqui roda com prefers-reduced-motion. O CSS já deixa tudo no estado
   final nessa condição; o JS apenas não interfere.

   O scroll passa por um único rAF compartilhado: são dois parallax na mesma
   página, e dois listeners escrevendo no DOM a 60fps competiriam.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var targets = [];      // {el, speed} — quem se move no scroll
  var ticking = false;

  /* progresso de 0 a 1 conforme o elemento cruza a janela */
  function progress(rect) {
    return (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
  }

  function frame() {
    ticking = false;
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      var r = (t.ref || t.el).getBoundingClientRect();
      var p = progress(r);
      t.el.style.transform = 'translateY(' + ((p - 0.5) * t.speed).toFixed(1) + 'px)';
    }
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(frame);
  }

  /* ---------- 3 e 5. entrada única ---------------------------------------- */
  function revealOnce(el, cls) {
    if (!el || el._efSeen || !('IntersectionObserver' in window)) {
      if (el) el.classList.add(cls);
      return;
    }
    el._efSeen = true;
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        el.classList.add(cls);
        io.disconnect();          // uma vez só: não repete no scroll de volta
      }
    }, { threshold: 0.25 });
    io.observe(el);
  }

  /* ---------- 4. os números contam de zero -------------------------------- */
  function countUp(root) {
    if (!root || root._efCounted) return;
    root._efCounted = true;

    var nums = root.querySelectorAll('[data-count]');
    if (!nums.length) return;

    function run() {
      var start = null;
      function tick(now) {
        if (start === null) start = now;
        var t = Math.min(1, (now - start) / 1100);
        var ease = 1 - Math.pow(1 - t, 3);
        nums.forEach(function (el) {
          var to = parseFloat(el.getAttribute('data-count'));
          var suffix = el.getAttribute('data-suffix') || '';
          el.textContent = Math.round(to * ease) + suffix;
        });
        if (t < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    if (!('IntersectionObserver' in window)) { run(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { run(); io.disconnect(); }
    }, { threshold: 0.4 });
    io.observe(root);
  }

  function init() {
    targets = [];

    if (!reduce.matches) {
      /* 1. hero: a camada se move dentro da moldura */
      document.querySelectorAll('[data-abhero-layer]').forEach(function (layer) {
        var frameEl = layer.closest('.ef-abhero__frame');
        if (frameEl) targets.push({ el: layer, ref: frameEl, speed: -60 });
      });

      /* 2. story: SINAIS OPOSTOS de propósito. O vídeo sobe e a foto desce, e é
         a distância entre os dois mudando que dá profundidade. Mesmo sinal
         deslocaria o bloco inteiro, o que não se nota. */
      document.querySelectorAll('[data-abstory]').forEach(function (sec) {
        var v = sec.querySelector('[data-abstory-video]');
        var p = sec.querySelector('[data-abstory-photo]');
        if (v) targets.push({ el: v, ref: sec, speed: -40 });
        if (p) targets.push({ el: p, ref: sec, speed: 56 });
      });
    }

    if (targets.length && !window._efAboutBound) {
      window._efAboutBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    if (targets.length) onScroll();

    document.querySelectorAll('.ef-abman').forEach(function (el) { revealOnce(el, 'is-in'); });
    document.querySelectorAll('.ef-abclose').forEach(function (el) { revealOnce(el, 'is-in'); });
    document.querySelectorAll('[data-abstats]').forEach(countUp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
